import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchCourses = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/courses${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createCourse = async (courseData) => {
  const response = await fetch(`${API_BASE_URL}/courses`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(courseData)
  });
  return handleResponse(response);
};

export const uploadCourseImage = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/courses/upload-image`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });
  return handleResponse(response);
};

export const updateCourse = async (id, courseData) => {
  const response = await fetch(`${API_BASE_URL}/courses/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(courseData)
  });
  return handleResponse(response);
};

export const deleteCourse = async (id) => {
  const response = await fetch(`${API_BASE_URL}/courses/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};



export const fetchVideos = async (courseId, moduleId) => {
  const response = await fetch(`${API_BASE_URL}/courses/${courseId}/modules/${moduleId}/videos`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const uploadVideoFile = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/videos/upload`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });
  return handleResponse(response);
};

export const trimVideoFile = async (trimData) => {
  const response = await fetch(`${API_BASE_URL}/videos/trim`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(trimData)
  });
  return handleResponse(response);
};

export const updateWatchDuration = async (trackingData) => {
  const response = await fetch(`${API_BASE_URL}/videos/track`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(trackingData)
  });
  return handleResponse(response);
};

export const fetchAvailableLogins = async () => {
  const response = await fetch(`${API_BASE_URL}/courses/logins`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchCourseAccess = async (courseId) => {
  const response = await fetch(`${API_BASE_URL}/courses/${courseId}/access`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const grantCourseAccess = async (courseId, payload) => {
  const response = await fetch(`${API_BASE_URL}/courses/${courseId}/access`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};

export const revokeCourseAccess = async (accessId) => {
  const response = await fetch(`${API_BASE_URL}/courses/access/${accessId}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};


